import React, {useState} from "react";
import {isEmpty} from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {OBJECT_TYPES} from "../../../constants/objectTypes";
import {useHandleCustomFieldsForObject} from "../../../hooks/useHandleCustomFieldsForObject";
import {sendCustomerModalData} from "../../../redux/Actions/customers.actions";
import {getOrganization} from "../../../redux/Selectors/root.selector";
import {useFetchCustomers} from "../customersTable/useCustomerTableData";

const DEFAULT_FORM_DATA = {name: ""};

export const useFormData = (data, onCancel) => {
  const dispatch = useDispatch();
  const {refetch} = useFetchCustomers();
  const [submitted, setSubmitted] = useState(false);
  const org = useSelector(getOrganization);
  const [formData, setFormData] = useState(data || DEFAULT_FORM_DATA);

  const setCustomFields = (customFields) => {
    setFormData((prevData) => ({
      ...prevData,
      custom_fields: customFields,
    }));
  };

  const {generateCustomFieldsPayload} = useHandleCustomFieldsForObject(
    OBJECT_TYPES.Customer,
    formData.id,
    setCustomFields
  );

  const {custom_fields = [], name = ""} = formData;

  const handleChange = (e) => {
    let updateObj = {...formData};
    updateObj = Object.assign({}, updateObj, {[e.target.name]: e.target.value});
    setFormData(updateObj);
  };

  const handleSubmit = () => {
    setSubmitted(true);

    if (!isEmpty(name)) {
      const callback = () => {
        onCancel();
        refetch();
      };
      let updateObj = {
        ...formData,
        custom_fields: generateCustomFieldsPayload(custom_fields),
        organization: org.id,
      };
      dispatch(sendCustomerModalData(updateObj, {defaultRoute: true}, callback));
    } else {
      toast.error("Please check required fields");
    }
  };

  return {
    formData,
    handleSubmit,
    handleChange,
    submitted,
  };
};
